/**
 * TrainingStats - Stats cards for training module
 * Extracted from TrainingView.jsx
 */

import { Video, Send, Check, Award } from 'lucide-react';

export default function TrainingStats({ videos = [], links = [], certificates = [] }) {
  // Ensure arrays are valid to prevent crashes
  const safeVideos = Array.isArray(videos) ? videos : [];
  const safeLinks = Array.isArray(links) ? links : [];
  const safeCertificates = Array.isArray(certificates) ? certificates : [];
  
  return (
    <div className="grid grid-cols-4 gap-4" data-testid="training-stats">
      <div className="bg-gradient-to-br from-red-500/25 to-red-600/10 rounded-2xl p-6 border border-red-500/30 text-center">
        <Video className="w-10 h-10 text-red-400 mx-auto mb-2" />
        <p className="text-2xl font-bold text-red-400" data-testid="stat-videos">{safeVideos.length}</p>
        <p className="text-sm text-red-400/70">Videos</p>
      </div>
      <div className="bg-gradient-to-br from-blue-500/25 to-blue-600/10 rounded-2xl p-6 border border-blue-500/30 text-center">
        <Send className="w-10 h-10 text-blue-400 mx-auto mb-2" />
        <p className="text-2xl font-bold text-blue-400" data-testid="stat-links-sent">{safeLinks.length}</p>
        <p className="text-sm text-blue-400/70">Links Sent</p>
      </div>
      <div className="bg-gradient-to-br from-green-500/25 to-green-600/10 rounded-2xl p-6 border border-green-500/30 text-center">
        <Check className="w-10 h-10 text-green-400 mx-auto mb-2" />
        <p className="text-2xl font-bold text-green-400" data-testid="stat-completed">{safeLinks.filter(l => l.status === 'watched').length}</p>
        <p className="text-sm text-green-400/70">Completed</p>
      </div>
      <div className="bg-gradient-to-br from-yellow-500/25 to-yellow-600/10 rounded-2xl p-6 border border-yellow-500/30 text-center">
        <Award className="w-10 h-10 text-yellow-400 mx-auto mb-2" />
        <p className="text-2xl font-bold text-yellow-400" data-testid="stat-certificates">{safeCertificates.length}</p>
        <p className="text-sm text-yellow-400/70">Certificates</p>
      </div>
    </div>
  );
}
